module.exports = __webpack_public_path__ + "static/img/kendoui.9d6320a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/shared-components/spreadsheet/kendoui/images/kendoui.svg
// module id = 1653
// module chunks = 28